import { LineKinds } from "../../../../../../../base/domain/drawing";
import { ILineGraphItem, ILineGraphPair, ILineGraphBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IGraphObjectBean } from "../../../beans/objects";
import { IGraphItemBean, IGraphValueBean } from "../../../beans/objects/items";
import { ItemsTranslator } from "./ItemsTranslator";
import { IntegerTranslator, ColorCodeTranslator } from "../../values";

export class LineGraphItemsTranslator {
  from(bean: IGraphObjectBean): ILineGraphItem[] {
    return this.items.from(
      bean.graphitem,
      s => {
        const pairs = this.pairs.from(s);
        const isTimeAxisDate = (pairs.length === 0) || (!pairs[0].timeAxis.isDate);
        return {
          name: s["@name"],
          range: {
            min: this.integer.from(s["@low-value"]),
            max: this.integer.from(s["@high-value"]),
          },
          isTimeAxisDate,
          lineStyle: {
            kind: LineKinds.Normal,
            color: {
              value: this.colorCode.from(s["@fg"]),
            },
            width: 1,
            opacity: 1,
          },
          pairs,
        };
      });
  }

  to(object: ILineGraphBehavior): IGraphItemBean | IGraphItemBean[] {
    return this.items.to(
      object.items,
      s => ({
        "@name": s.name,
        "@low-value": this.integer.to(s.range.min),
        "@high-value": this.integer.to(s.range.max),
        "@fg": this.colorCode.to(s.lineStyle.color.value),
        "@bg": "ffffff",                              // 設定UIなし.固定値.
        "graphvalue": this.pairs.to(s),
      }),
    );
  }

  private readonly items = new ItemsTranslator();
  private readonly integer = new IntegerTranslator();
  private readonly colorCode = new ColorCodeTranslator();
  private readonly pairs = new LineGraphPairsTranslator();
}

export class LineGraphPairsTranslator {
  from(bean: IGraphItemBean): ILineGraphPair[] {
    return this.items.from(
      bean.graphvalue,
      s => ({
        timeAxis: {
          page: this.integer.from(s["@date-page"]),
          type: s["@date-type"] === "time" ? "date" : s["@date-type"],  // isDateで判断するためtimeはdateに設定する
          id: this.integer.from(s["@date-obj-id"]),
          key: s["@date-key"],
          subKey: s["@date-subkey"],
          isDate: s["@date-type"] === "date"
        },
        value: {
          page: this.integer.from(s["@value-page"]),
          type: s["@value-type"],
          id: this.integer.from(s["@value-obj-id"]),
          key: s["@value-key"],
          subKey: s["@value-subkey"],
        },
      }));
  }

  to(object: ILineGraphItem): IGraphValueBean | IGraphValueBean[] {
    return this.items.to(
      object.pairs,
      s => ({
        "@item-type": "1",                              // 折れ線グラフ専用.固定値.
        "@date-page": this.integer.to(s.timeAxis.page),
        "@date-type": s.timeAxis.isDate ? "date" : "time",
        "@date-key": s.timeAxis.key,
        "@date-obj-id": this.integer.to(s.timeAxis.id),
        "@date-subkey": s.timeAxis.subKey,
        "@value-page": this.integer.to(s.value.page),
        "@value-type": s.value.type,
        "@value-key": s.value.key,
        "@value-subkey": s.value.subKey,
        "@value-obj-id": this.integer.to(s.value.id),
      }));
  }

  private readonly items = new ItemsTranslator();
  private readonly integer = new IntegerTranslator();
}
